/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.7.1.0 (NJsonSchema v9.6.0.0) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class DashboardAPIService {
  private http: Http;
  private baseUrl: string;
  protected jsonParseReviver: (key: string, value: any) => any = undefined;

  constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = configSvc.config.serviceUrl.dashboard;
    }

    getPowerBIEmbedTokenByUser(embeddedObjectType: EmbeddedObjectType, pbParentId: string, pbObjectId: string, pbSubObjectId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/dashboard/powerbiembedtoken?";
        if (embeddedObjectType === undefined || embeddedObjectType === null)
            throw new Error("The parameter 'embeddedObjectType' must be defined and cannot be null.");
        else
            url_ += "embeddedObjectType=" + encodeURIComponent("" + embeddedObjectType) + "&"; 
        if (pbParentId === undefined)
            throw new Error("The parameter 'pbParentId' must be defined.");
        else
            url_ += "pbParentId=" + encodeURIComponent("" + pbParentId) + "&"; 
        if (pbObjectId === undefined)
            throw new Error("The parameter 'pbObjectId' must be defined.");
        else
            url_ += "pbObjectId=" + encodeURIComponent("" + pbObjectId) + "&"; 
        if (pbSubObjectId !== undefined)
            url_ += "pbSubObjectId=" + encodeURIComponent("" + pbSubObjectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetPowerBIEmbedTokenByUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPowerBIEmbedTokenByUser(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetPowerBIEmbedTokenByUser(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    getDashboardData(dashboardSearch: DashboardSearch): Observable<boolean> {
        let url_ = this.baseUrl + "/api/dashboard/DashboardData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardSearch);
        
        let options_ = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_) => {
            return this.processGetDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardData(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardData(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status === 500) {
            const _responseText = response.text();
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = resultData500 ? CustomError.fromJS(resultData500) : <any>null;
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

export enum EmbeddedObjectType {
    Report = 1, 
    Dashboard = 2, 
    Tile = 3, 
}

export class CustomError implements ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;

    constructor(data?: ICustomError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.severity = data["Severity"] !== undefined ? data["Severity"] : <any>null;
            this.statusCode = data["StatusCode"] !== undefined ? data["StatusCode"] : <any>null;
            this.correlationId = data["CorrelationId"] !== undefined ? data["CorrelationId"] : <any>null;
            this.message = data["Message"] !== undefined ? data["Message"] : <any>null;
            this.exceptionType = data["ExceptionType"] !== undefined ? data["ExceptionType"] : <any>null;
        }
    }

    static fromJS(data: any): CustomError {
        let result = new CustomError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Severity"] = this.severity !== undefined ? this.severity : <any>null;
        data["StatusCode"] = this.statusCode !== undefined ? this.statusCode : <any>null;
        data["CorrelationId"] = this.correlationId !== undefined ? this.correlationId : <any>null;
        data["Message"] = this.message !== undefined ? this.message : <any>null;
        data["ExceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        return data; 
    }
}

export interface ICustomError {
    severity: SeverityEnum;
    statusCode: HttpStatusCode;
    correlationId?: string;
    message?: string;
    exceptionType?: string;
}

export enum SeverityEnum {
    None = 0, 
    Warning = 1, 
    Error = 2, 
    Exception = 3, 
}

export enum HttpStatusCode {
    Continue = 100, 
    SwitchingProtocols = 101, 
    OK = 200, 
    Created = 201, 
    Accepted = 202, 
    NonAuthoritativeInformation = 203, 
    NoContent = 204, 
    ResetContent = 205, 
    PartialContent = 206, 
    MultipleChoices = 300, 
    Ambiguous = 300, 
    MovedPermanently = 301, 
    Moved = 301, 
    Found = 302, 
    Redirect = 302, 
    SeeOther = 303, 
    RedirectMethod = 303, 
    NotModified = 304, 
    UseProxy = 305, 
    Unused = 306, 
    TemporaryRedirect = 307, 
    RedirectKeepVerb = 307, 
    BadRequest = 400, 
    Unauthorized = 401, 
    PaymentRequired = 402, 
    Forbidden = 403, 
    NotFound = 404, 
    MethodNotAllowed = 405, 
    NotAcceptable = 406, 
    ProxyAuthenticationRequired = 407, 
    RequestTimeout = 408, 
    Conflict = 409, 
    Gone = 410, 
    LengthRequired = 411, 
    PreconditionFailed = 412, 
    RequestEntityTooLarge = 413, 
    RequestUriTooLong = 414, 
    UnsupportedMediaType = 415, 
    RequestedRangeNotSatisfiable = 416, 
    ExpectationFailed = 417, 
    UpgradeRequired = 426, 
    InternalServerError = 500, 
    NotImplemented = 501, 
    BadGateway = 502, 
    ServiceUnavailable = 503, 
    GatewayTimeout = 504, 
    HttpVersionNotSupported = 505, 
}

export class DashboardSearch implements IDashboardSearch {
    reportBeginDate?: string;
    reportEndDate?: string;
    objectType?: string;
    objectIdList?: string[];

    constructor(data?: IDashboardSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reportBeginDate = data["ReportBeginDate"] !== undefined ? data["ReportBeginDate"] : <any>null;
            this.reportEndDate = data["ReportEndDate"] !== undefined ? data["ReportEndDate"] : <any>null;
            this.objectType = data["ObjectType"] !== undefined ? data["ObjectType"] : <any>null;
            if (data["ObjectIdList"] && data["ObjectIdList"].constructor === Array) {
                this.objectIdList = [];
                for (let item of data["ObjectIdList"])
                    this.objectIdList.push(item);
            }
        }
    }

    static fromJS(data: any): DashboardSearch {
        let result = new DashboardSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReportBeginDate"] = this.reportBeginDate !== undefined ? this.reportBeginDate : <any>null;
        data["ReportEndDate"] = this.reportEndDate !== undefined ? this.reportEndDate : <any>null;
        data["ObjectType"] = this.objectType !== undefined ? this.objectType : <any>null;
        if (this.objectIdList && this.objectIdList.constructor === Array) {
            data["ObjectIdList"] = [];
            for (let item of this.objectIdList)
                data["ObjectIdList"].push(item);
        }
        return data; 
    }
}

export interface IDashboardSearch {
    reportBeginDate?: string;
    reportEndDate?: string;
    objectType?: string;
    objectIdList?: string[];
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
	headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
		super();

        this.message = message;
        this.status = status;
        this.response = response;
		this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => { 
        let reader = new FileReader(); 
        reader.onload = function() { 
            observer.next(this.result);
            observer.complete();
        }
        reader.readAsText(blob); 
    });
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.DashboardTokenApi.service.ts